import React from "react";
import { useLang, translations } from "@/i18n";
import { HOME_COPY as C } from "@/data/homeContent";
import { HomeMedia } from "./HomeMedia";
import { Reveal, SectionLabel, TextLink } from "./HomePrimitives";

export const HomeIntro = () => {
  const { t } = useLang();
  return <section id="ritual" className="rh-intro-band" data-testid="home-intro"><div className="rh-intro rh-wrap">
    <Reveal className="rh-intro-copy">
      <SectionLabel testId="home-intro-heading">{t(C.introLabel)}</SectionLabel>
      <p className="rh-statement rh-intro-statement" data-testid="intro-manifesto-heading">{t(C.introLine1)}<br /><em>{t(C.introLine2)}</em></p>
      <div className="rh-intro-note"><p className="rh-body" data-testid="home-intro-description">{t(C.introBody)}</p><TextLink to="/historia" testId="home-historia-link">{t(C.history)}</TextLink></div>
    </Reveal>
    <Reveal className="rh-intro-photo"><figure><HomeMedia name="intro" sizes="(max-width: 767px) 80vw, 30vw" /><figcaption data-testid="home-intro-caption">{t(C.introCaption)}</figcaption></figure></Reveal>
  </div></section>;
};

export const HomeGastronomy = () => {
  const { t } = useLang();
  return <section className="rh-gastronomy" data-testid="home-gastronomy">
    <div className="rh-gastro-main rh-wrap">
      <Reveal className="rh-gastro-photo"><figure><HomeMedia name="gastronomy" /><figcaption data-testid="home-gastro-caption">{t(C.gastroCaption)}</figcaption></figure></Reveal>
      <Reveal className="rh-gastro-copy">
        <SectionLabel testId="home-gastro-heading" number="02">{t(C.gastroLabel)}</SectionLabel>
        <p className="rh-statement" data-testid="home-gastro-statement">{t(C.gastroLine1)}<br /><em>{t(C.gastroLine2)}</em></p>
        <p className="rh-body" data-testid="home-gastro-description">{t(C.gastroBody)}</p>
        <TextLink to="/carta" testId="gastro-ver-carta-link">{t(translations.common.viewMenu)}</TextLink>
      </Reveal>
    </div>
    <div className="rh-gastro-breakfast rh-wrap"><span className="rh-breakfast-caption" data-testid="home-breakfast-caption">{t(C.breakfastCaption)}</span><Reveal><HomeMedia name="breakfast" sizes="(max-width: 767px) 85vw, 48vw" /></Reveal></div>
  </section>;
};

export const HomeCoffee = () => {
  const { t } = useLang();
  return <section className="rh-coffee rh-wrap" data-testid="home-coffee">
    <Reveal className="rh-coffee-copy">
      <SectionLabel testId="home-coffee-heading" number="03">{t(C.coffeeLabel)}</SectionLabel>
      <p className="rh-statement" data-testid="home-coffee-statement">{t(C.coffeeLine1)}<br /><em>{t(C.coffeeLine2)}</em></p>
      <p className="rh-body" data-testid="home-coffee-description">{t(C.coffeeBody)}</p>
      <TextLink to="/naguara" testId="cafe-descubrir-naguara-link">{t(C.naguaraDiscover)}</TextLink>
    </Reveal>
    <Reveal className="rh-coffee-photo"><figure><HomeMedia name="coffee" sizes="(max-width: 767px) 90vw, 45vw" /><figcaption data-testid="home-coffee-caption">{t(C.coffeeCaption)}</figcaption></figure></Reveal>
  </section>;
};